import React from 'react';
import { Helmet } from "react-helmet";
import { Box, CssBaseline } from '@mui/material';
import PrimarySearchAppBar from './Components/Header';
import Sidebar from './Components/Sidebar';
import ComplisenseLogo from './Components/ComplisenseLogo';
import './footer.css';  // Ensure that your footer styles are imported
const Layout = (props) => {
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <>
            <Helmet>
                <meta charSet="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <title>{props.title}</title>
            </Helmet>
            <CssBaseline />
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100%' }}>
                <PrimarySearchAppBar handleDrawerToggle={handleDrawerToggle} sx={{ width: '100%' }} />
                <Sidebar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />

                {/* Main content area */}
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        mt: theme => theme.spacing(8),
                        maxWidth: { sm: `100v%` },
                    }}
                >
                    {props.children}
                </Box>

                {/* Footer */}
                <footer className="footer" style={{ width: '100%' }}>
                    <div className="footer-content">
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5, mb: 1, color: 'rgba(255,255,255,0.95)' }}>
                            <ComplisenseLogo
                                variant="wordmark"
                                size="small"
                                iconSize={28}
                                typographySx={{ color: 'inherit', fontSize: '1rem' }}
                            />
                        </Box>
                        <p>Powered by Complisense © 2024 All Rights Reserved.</p>
                    </div>
                </footer>
            </Box >
        </>
    );
}

export default Layout;
